export default "__VITE_ASSET__BYSkai$p__"